/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

import Fade from 'react-reveal/Fade';
import Button from 'elements/Button';

export default function EnterpriseSupport({ data }) {
  return (
    <section className="relative container mx-auto py-24 px-4 overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-theme-purple/5 rounded-full blur-3xl transform translate-x-1/4 -translate-y-1/4" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-dark-theme-purple/5 rounded-full blur-3xl transform -translate-x-1/4 translate-y-1/4" />

      <div className="relative z-10">
        <Fade bottom>
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-2xl mb-6">
              <svg className="w-10 h-10 text-theme-purple" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            </div>
            <h2 className="text-4xl lg:text-5xl text-theme-blue font-bold mb-4">
              Enterprise Support
            </h2>
            <p className="font-light text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              ERapid Technologies offers you enterprise-grade support which includes
              comprehensive and specialized technical support and assistance for your large-scale
              enterprise-level software.
            </p>
            <Button href="/discuss-project" type="link" className="inline-flex items-center px-8 py-3 bg-gradient-to-r from-theme-purple to-dark-theme-purple text-white rounded-lg shadow-lg hover:shadow-xl transform transition-all duration-300 hover:scale-105">
              Know More
              <svg className="ml-2 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </Button>
          </div>
        </Fade>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {data.map((item, index) => (
            <Fade bottom delay={200 * index} key={item.title}>
              <div className="group relative bg-white rounded-xl shadow-md border border-gray-100 p-6 transform transition-all duration-300 hover:shadow-xl hover:scale-105 overflow-hidden">
                {/* Decorative gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-theme-purple/5 to-dark-theme-purple/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

                {/* Corner decoration */}
                <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-theme-purple/10 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

                <div className="relative z-10">
                  <div className="flex items-start mb-4">
                    <div className="relative w-14 h-14 bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-lg flex items-center justify-center flex-shrink-0 mr-4 group-hover:from-theme-purple/20 group-hover:to-dark-theme-purple/20 transition-all duration-300">
                      <svg className="w-7 h-7 text-theme-purple" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      {/* Animated ring */}
                      <div className="absolute inset-0 rounded-lg border-2 border-theme-purple/30 opacity-0 group-hover:opacity-100 group-hover:animate-pulse transition-opacity duration-300" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-theme-blue mb-2 group-hover:text-theme-purple transition-colors duration-300">{item.title}</h3>
                      <p className="text-sm text-gray-600 leading-relaxed">{item.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </section>
  );
}
